/* eslint-disable no-restricted-syntax */
export const getExpandedMenuByPath = (navigationData, path) => {
  let result = '';
  if (path === '/') {
    return ['cms'];
  }

  const findUrl = (children, parentId = null) => {
    for (const item of children) {
      const { id, children: subChildren, url } = item;
      const hasSubChildren = Array.isArray(subChildren) && subChildren.length > 0;
      if (hasSubChildren) {
        findUrl(subChildren, id);
        const { subId, children: subSubChildren, subUrl } = item;
        const hasSubSubChildren = Array.isArray(subSubChildren) && subSubChildren.length > 0;
        if (hasSubSubChildren) {
          findUrl(subSubChildren, subId);
        }
        if (subUrl === path) {
          result = id || subId;
          break;
        }
      }
      if (url === path) {
        result = parentId || id;
        break;
      }
    }
  };
  findUrl(navigationData);

  return [result];
};
